import {
  put,
  call,
  take,
  every,
  takeLatest,
  takeEvery,
} from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* documentCategoryListSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DOCUMENT_CATEGORY_LIST, payload);
    if (response.status == 200) {
      yield put(ACTION.documentCategoryList_Success(response.data));
    } else {
      yield put(ACTION.documentCategoryList_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.documentCategoryList_Fail(response.data.error));
  }
}
function* EditDocumentCategorysaga({ payload, callBack }) {
  try {
    const response = yield call(API.EDIT_MANAGE_DOCUMENT_CATEGORY, payload);
    if (response.status == 200) {
      yield put(ACTION.editDocumentCategory_Success(response.data));
    } else {
      yield put(ACTION.editDocumentCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.editDocumentCategory_Fail(response.data.error));
  }
}
function* updateDocumentCategorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.UPDATE_DOCUMENT_CATEGORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.updateDocumentCategory_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.updateDocumentCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.updateDocumentCategory_Fail(response.data.error));
  }
}
function* addDocumentCategorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.ADD_DOCUMENT_CATEGORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.addDocumentCategory_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.addDocumentCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.addDocumentCategory_Fail(response.data.error));
  }
}
function* deleteDocumentCategorySaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_DOCUMENT_CATEGORY, payload);
    callBack && callBack(response.data);
    if (response.data.data) {
      yield put(ACTION.deleteDocumentCategory_Success(response.data));
    } else {
      toast.error(response.data.error);
      yield put(ACTION.deleteDocumentCategory_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteDocumentCategory_Fail(response.data.error));
  }
}

function* DocumentCategorySaga() {
  yield takeEvery(CONST.DOCUMENT_CATEGORY_LIST, documentCategoryListSaga);
  yield takeEvery(CONST.EDIT_DOCUMENT_CATEGORY, EditDocumentCategorysaga);
  yield takeEvery(CONST.UPDATE_DOCUMENT_CATEGORY, updateDocumentCategorySaga);
  yield takeEvery(CONST.ADD_DOCUMENT_CATEGORY, addDocumentCategorySaga);
  yield takeEvery(CONST.DELETE_DOCUMENT_CATEGORY, deleteDocumentCategorySaga);
}

export default DocumentCategorySaga;
